<template>
  <div :id="'chart_'+uuid">
    <div class="chart-container" style="position: relative;" :style="`width: ${size.width}; height: ${size.height};`">
      <canvas :id="uuid" :width="size.width" :height="size.height"/>
    </div>
  </div>
</template>

<script>
import { Chart } from "chart.js/auto";
export default {
  name: "e932ea24-1cc5-11eb-8116-00155d01060e",
  props: ['chart', 'size', 'title', 'uuid'],
  mounted() {
    this.canvas = document.getElementById(this.uuid).getContext('2d')
    this.make_chart()
  },
  computed: {
    report_data() {
      return this.chart.report_data
    }
  },
  watch: {
    report_data() {
      this.update_chart()
    }
  },
  data() {
    return {
      canvas: null,
      graph: null,
      date: [],
      proc: [],
      reds: [],
      datasets: []
    }
  },
  methods: {
    make_chart: function () {
      this.update_data()
      let chartus = this.chart
      if (this.canvas) {
        this.update_data()
        this.graph = new Chart(this.canvas, {
          type: 'line',
          data: {
            labels: this.date,
            datasets: this.datasets
          },
          options: {
            elements: {
              point: {
                radius: function(data) {
                  if (data.raw < chartus.report_control_line) {
                    return 3
                  } else {
                    return 0
                  }
                },
                pointBackgroundColor: function (data) {
                  if (data.raw < chartus.report_control_line) {
                    return '#f3aeae'
                  } else {
                    return null
                  }
                },
                pointBorderColor: function (data) {
                  if (data.raw < chartus.report_control_line) {
                    return '#bd5858'
                  } else {
                    return null
                  }
                }
              }
            },
            stepped: 'after',
            scales: {
              y: {
                max: 100,
                beginAtZero: true,
                title: {
                  display: true,
                  text: 'Процент работоспособности'
                }
              }
            },
            plugins: {
              autocolors: {
                offset: 4
              },
              datalabels: {
                display: false
              },
              legend: {
                display: false
              }
            }
          }
        })
      }
    },
    update_data: function () {
      this.date = []
      this.proc = []
      this.reds = []
      this.datasets = []

      let red_line = this.chart.report_control_line
      for (let i = 0; i < this.chart.report_data.length; i++) {
        if (!this.date.includes(this.chart.report_data[i]["Дата"])) {this.date.push(this.chart.report_data[i]["Дата"])}
        this.proc.push(this.chart.report_data[i]["ИтоговыйПроцент"])
        this.reds.push(red_line)
      }

      for (let i = 0; i < this.date.length; i++) {
        let tmp = new Date(Date.parse(this.date[i]))
        let options = {
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        }
        this.date[i] = tmp.toLocaleString("ru-RU", options)
      }

      this.datasets.push({
        label: 'Итоговый процент',
        data: this.proc,
        pointStyle: 'circle',
        //pointRadius: 0,
        fill: true,
        order: 1
      })

      if (red_line > 0) {
        this.datasets.push({
          label: 'Контрольная линия',
          data: this.reds,
          type: 'line',
          order: 0,
          fill: false,
          datalabels: {
            display: false
          },
          tooltip: {
            enabled: false,
          },
          pointRadius: 0
        })
      }
    },
    update_chart: function () {
      this.update_data()
      this.graph.destroy()
      this.canvas = document.getElementById(this.uuid).getContext('2d')
      this.make_chart()
    }
  }
}
</script>